<template>
  <v-app>
    <v-content class="main-container">
      <default-header :is-login="!!$store.state.accessToken" transparent />
      <nuxt></nuxt>
    </v-content>
    <snack-bar-container></snack-bar-container>
  </v-app>
</template>

<script>
import SnackBarContainer from '~/components/organisms/SnackBarContainer'
import DefaultHeader from '~/components/organisms/Header'

export default {
  components: {
    SnackBarContainer,
    DefaultHeader
  }
}
</script>
